import React, { useMemo } from 'react';
import ProductItem from './ProductItem';

import prd1 from "../../assets/images/prd1.png";
import prd2 from "../../assets/images/prd2.png";
import prd3 from "../../assets/images/prd3.png";
import prd4 from "../../assets/images/prd4.png";

import searchIcon from '../../assets/icons/search.png';
import clockIcon from '../../assets/icons/clock.png';
import scaleIcon from '../../assets/icons/scale.png';
import messageIcon from '../../assets/icons/message.png';
import interactionIcon from '../../assets/icons/interaction.png';
import qualifiedIcon from '../../assets/icons/pre.png';
import actionIcon from '../../assets/icons/action.png';
import conversionIcon from '../../assets/icons/convert.png';

// Memoize product data to prevent unnecessary re-renders
const products = [
  {
    heading: "Automated Lead Generation",
    image: prd1,
    features: [
      {
        icon: searchIcon,
        heading: "Identify potential leads",
        content: "Continuously monitor Facebook groups for rental-seeking posts.",
      },
      {
        icon: clockIcon,
        heading: "Save time",
        content: "Eliminate manual searching for leads.",
      },
      {
        icon: scaleIcon,
        heading: "Scalability",
        content: "Monitor a varying number of groups based on your pricing plan.",
      },
    ],
  },
  {
    heading: "Personalized Messaging",
    image: prd2,
    features: [
      {
        icon: messageIcon,
        heading: "Automated messages",
        content: "Generate tailored messages for each lead.",
      },
      {
        icon: clockIcon,
        heading: "Save time",
        content: "Avoid manual message creation.",
      },
      {
        icon: interactionIcon,
        heading: "Engaging interactions",
        content: "Ensure relevant and personalized communication.",
      },
    ],
  },
  {
    heading: "Qualified Leads",
    image: prd3,
    features: [
      {
        icon: qualifiedIcon,
        heading: "Pre-qualification",
        content: "Our team assesses leads before sending them to agents.",
      },
      {
        icon: actionIcon,
        heading: "Action-ready leads",
        content: "Receive only qualified prospects.",
      },
      {
        icon: conversionIcon,
        heading: "Increased conversion rates",
        content: "Focus on leads more likely to close deals.",
      },
    ],
  },
  {
    heading: "Time and Cost Efficiency",
    image: prd4,
    features: [
      {
        icon: messageIcon,
        heading: "Focus on core business",
        content: "Delegate lead generation tasks.",
      },
      {
        icon: clockIcon,
        heading: "Increased revenue",
        content: "Generate more leads and close more deals.",
      },
      {
        icon: interactionIcon,
        heading: "Improved workflow",
        content: "Streamline your processes and save time.",
      },
    ],
  },
];

function Products() {
  const memoizedProducts = useMemo(() => products, []);

  return (
    <div className="space-y-12">
      {memoizedProducts.map((product, index) => (
        <ProductItem
          key={index}
          left={index % 2 === 0}
          {...product}
        />
      ))}
    </div>
  );
}

export default React.memo(Products);
